import React, { Component } from "react";
import { Field } from "redux-form";
import { FormGroup, Label } from "reactstrap";
import Aux from "../../../system/containers/Aux";
import TextInput from "../../../system/fields/TextInput";
import SelectDropdown from '../../../system/fields/SelectDropdown';
import * as validations from "../../../system/utils/Validation";

const travelTypes = [
  {
    id: 1,
    name: 'Plane',
  },
  {
    id: 2,
    name: 'Car',
  },
  {
    id: 3,
    name: 'Bus',
  },
  {
    id: 4,
    name: 'Train',
  },
  {
    id: 5,
    name: 'Boat',
  }
];

class TravelLegs extends Component {
  constructor(props, leg, index, fields) {
    super(props);
  }

  render() {
    return (
      <Aux>
        <div className="row top-field">
          <FormGroup className="col-12 col-sm-8">
            <Label htmlFor="email">Leg Title</Label>
            <Field
              name={`${this.props.leg}.leg_detail.name`}
              component={TextInput}
              placeholder="E.G. Take a plane from a to b"
              type="text"
              validate={validations.required}
              autoFocus={true}
            />
          </FormGroup>
          <FormGroup className="col-12 col-sm-4">
            <Label>Travel Type</Label>
            <Field
              name={`${this.props.leg}.leg_detail.travel_type`}
              component={SelectDropdown}
              options={travelTypes}
              labelKey={"name"}
              valueKey={"id"}
              type="text"
              multi={false}
              className="form-control"
            />
          </FormGroup>
        </div>
      </Aux>
    );
  }
}

export default TravelLegs;



// WEBPACK FOOTER //
// ./src/containers/Deals/components/TravelLegs.jsx